module.exports = __webpack_public_path__ + "img/20201213_133758.c68d8181.jpg";